import { render, staticRenderFns } from "./ModalInvalidItems.vue?vue&type=template&id=6687a430&scoped=true"
import script from "./ModalInvalidItems.vue?vue&type=script&lang=js"
export * from "./ModalInvalidItems.vue?vue&type=script&lang=js"
import style0 from "./ModalInvalidItems.vue?vue&type=style&index=0&id=6687a430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6687a430",
  null
  
)

export default component.exports